import React from 'react';

import {IconsMap} from 'components/dynamic-icon';
import {ProgressCell, TEditableColumn} from 'components/editable-table';
import {TEntityValue} from 'modules/data';
import {IDocumentUploadScan, EFileUploadStatus} from 'store/slices/documents-uploading-slice';

interface IGetUploadScanFilesColumnsMetaArgs {
    progress?: {
        percent: number;
        status?: EFileUploadStatus;
    };
    handleDelete: (record: Record<string, TEntityValue>) => void;
    documentsForUploadAttach: any;
}

export const SCAN_UPLOAD_UID = Symbol('uid');

export const getUploadScanFilesColumnsMeta = (args?: IGetUploadScanFilesColumnsMetaArgs) => {
    const {
        progress,
        handleDelete,
        documentsForUploadAttach,
    } = args ?? {};

    return [{
        key: 'actions',
        title: '',
        dataIndex: 'actions',
        width: '35',
        order: 1,
        fixed: 'left',
        render: (_: any, record: Record<string, IDocumentUploadScan>) => (
            <IconsMap.CloseX
                style={{cursor: 'pointer', marginTop: 5}}
                onClick={() => handleDelete?.(record)}
            />
        ),
    }, {
        key: 'progress',
        title: 'Загрузка',
        dataIndex: 'progress',
        align: 'center',
        width: '87',
        order: 2,
        fixed: 'left',
        render: value => (
            <ProgressCell
                percent={value?.percent ?? progress?.percent ?? 0}
                status={value?.status ?? progress?.status}
            />
        ),
    }, {
        key: 'fileName',
        title: 'Файл документа',
        dataIndex: 'fileName',
        width: '250',
        order: 3,
        fixed: 'left',

    }, {
        required: true,
        key: 'documentFileId',
        isRequired: true,
        title: 'Имя файла документа',
        dataIndex: 'documentFileId',
        inputType: 'SELECT',
        width: '372',
        alwaysEditable: true,
        editable: true,
        placeholder: 'Выберите имя документа',
        order: 4,
        fixed: 'left',
        generateInputProps: () => ({
            options: (documentsForUploadAttach ?? []).map((doc: any) => ({
                value: doc.id,
                label: doc.meaning,
            })),
        }),
        getFieldState: (_, record) => ({required: true, disabled: record.isSubmitted}),
    },
    {
        key: 'documentName',
        isDisabled: true,
        title: 'Наименование документа',
        dataIndex: 'documentName',
        inputType: 'TEXT',
        width: '472',
        alwaysEditable: true,
        editable: true,
        placeholder: 'Выберите наименование документа',
        order: 5,
    }, {
        key: 'documentTypeName',
        title: 'Тип',
        dataIndex: 'documentTypeName',
        isDisabled: true,
        inputType: 'TEXT',
        width: '252',
        alwaysEditable: true,
        editable: true,
        placeholder: 'Тип',
        order: 6,
    }, {
        key: 'sectionCode',
        isDisabled: true,
        title: 'Раздел',
        dataIndex: 'sectionCode',
        inputType: 'TEXT',
        width: '235',
        alwaysEditable: true,
        editable: true,
        placeholder: 'Выберите раздел',
        order: 7,
    }] as TEditableColumn[];
};
